import dynamic from 'next/dynamic';

const ProductReviewFormDialog = dynamic(() => import('./product-review-form-dialog'), { ssr: false });

let isLoaded = false;

const ProductReviewFormLazyLoad = props => {
  const { open } = props;

  if (open) {
    isLoaded = true;
  }

  return isLoaded && <ProductReviewFormDialog {...props} />;
};

export default ProductReviewFormLazyLoad;
